module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Stark, Lawrence Block\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Richard Stark")]), _vm._v(" was one of the many pseudonyms of Donald E. Westlake (1933–2008), a prolific author of noir crime fiction. In 1993 the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dSq7JG/tc-custom/9780226772981.jpg?1724818070484",
      "alt": "This image is the cover for the book Butcher's Moon, The Parker Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Butcher's Moon, The Parker Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The sixteenth Parker novel, "), _c('i', [_vm._v("Butcher’s Moon")]), _vm._v(" is more than twice as long as most of the master heister’s adventures, and absolutely jammed with the action, violence, and nerve-jangling tension readers have come to expect. Back in the corrupt town where he lost his money, and nearly his life, in "), _c('i', [_vm._v("Slayground")]), _vm._v(", Parker assembles a stunning cast of characters from throughout his career for one gigantic, blowout job: starting—and finishing—a gang war. It feels like the Parker novel to end all Parker novels, and for nearly twenty-five years that’s what it was. After its publication in 1974, Donald Westlake said, “Richard Stark proved to me that he had a life of his own by simply disappearing. He was gone.”"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Featuring a new introduction by Westlake’s close friend and writing partner, Lawrence Block, this classic Parker adventure deserves a place of honor on any crime fan’s bookshelf. More than thirty-five years later, "), _c('i', [_vm._v("Butcher’s Moon")]), _vm._v(" still packs a punch: keep your calendar clear when you pick it up, because once you open it you won’t want to do anything but read until the last shot is fired.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0